import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";

export default class AdminsTickets extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 10;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Date",
				id: 'created',
				/** @param {Tickets_Object} obj */
				accessor: obj => moment(obj.created).local().format('MM/DD/YYYY h:mm A'),
			},
			{
				Header: "Engineer",
				id: 'field_engineer',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.assigned ? `${obj.field_engineers?.name_first} ${obj.field_engineers?.name_last}` : '',
				Cell: (props) => {
					let {original} = props;
					let {field_engineers} = original;

					if (!original.assigned) return null;

					return (
						<span>
							<Link to={`/users/${field_engineers?.pkey}`}>
								{`${field_engineers?.name_first} ${field_engineers?.name_last}`}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Ticket",
				id: "fresh_ticket",
				//width: 65,
				/** @param {Tickets_Object} props.original */
				Cell: props => <FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
			},
			{
				Header: "Client",
				id: 'customers.name',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.customers ? obj.customers.name : '',
			},
			{
				Header: "Open",
				id: 'opened',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.opened ?  moment(obj.opened).local().format('MM/DD/YYYY h:mm A') : '',
			},
			{
				Header: "Closed",
				id: 'closed',
				/** @param {Tickets_Object} obj */
				accessor: obj => obj.closed ? moment(obj.closed).local().format('MM/DD/YYYY h:mm A') : '',
			},
			// {
			// 	Header: "Payment",
			// 	accessor: "payment",
			// },
			// {
			// 	Header: "Labor",
			// 	accessor: 'labor',
			// },
			// {
			// 	Header: "AV",
			// 	accessor: 'av',
			// },
			// {
			// 	Header: "Parts",
			// 	accessor: 'parts',
			// },
			// {
			// 	Header: "Notes",
			// 	accessor: 'notes',
			// },
			// {
			// 	Header: "Expected",
			// 	accessor: 'expected',
			// },
			// {
			// 	Header: "% Off",
			// 	accessor: 'percent_off',
			// },
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Link to={"/tickets/" + props.original.pkey}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Appointments')}
							{this.renderHeaderRight("Appointments",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
